import { CategoriesSection } from 'app/src/features/Proposals/components/CategoriesSection'
import { HowToSection } from 'app/src/features/Proposals/components/HowToSection'
import { InfoEmailSection } from 'app/src/features/Proposals/components/InfoEmailSection'
import { InstructionLinkSection } from 'app/src/features/Proposals/components/InstructionLinkSection'
import { SuggestSection } from 'app/src/features/Proposals/components/SuggestSection'
import { pageconfigurationsApi } from 'app/src/services/welfareportal'
import { DynamicPageWidget } from 'app/src/shared/components'
import { useWebAppContext } from 'app/src/shared/hooks'
import { useEffect, useState, type ReactElement } from 'react'

export function ComponentRenderer(
  sections: pageconfigurationsApi.SectionItem[],
  onFinalStepCompleted?: () => void,
): ReactElement {
  const context = useWebAppContext()
  const [visibleSections, setVisibleSections] = useState<string[]>([])

  useEffect(() => {
    if (visibleSections.length === 0) {
      setVisibleSections(sections.map((section) => section.sectionName))
    }
  }, [sections, visibleSections])

  const handleFinalStepCompleted = () => {
    setVisibleSections(['ProposalCategoriesSection'])
    if (onFinalStepCompleted) {
      onFinalStepCompleted()
    }
  }

  return (
    <>
      {sections.map((section) => {
        if (!visibleSections.includes(section.sectionName)) {
          return null
        }

        switch (section.sectionName) {
          case 'ProposalSuggestSection':
            return (
              <DynamicPageWidget
                key={section.sectionName}
                componentRenderer={(props) => <SuggestSection {...props} />}
                sectionItem={section}
              />
            )

          case 'ProposalHowToSection':
            return (
              <DynamicPageWidget
                key={section.sectionName}
                componentRenderer={(props) => <HowToSection {...props} />}
                sectionItem={section}
              />
            )

          case 'ProposalInfoEmailSection':
            return (
              <DynamicPageWidget
                key={section.sectionName}
                componentRenderer={(props) => <InfoEmailSection {...props} />}
                sectionItem={section}
              />
            )

          case 'ProposalCategoriesSection':
            return (
              <DynamicPageWidget
                key={section.sectionName}
                componentRenderer={(props) => <CategoriesSection {...props} onFinalStepCompleted={handleFinalStepCompleted} />}
                sectionItem={section}
              />
            )

          case 'ProposalInstructionLinkSection':
            return (
              <DynamicPageWidget
                key={section.sectionName}
                componentRenderer={(props) => <InstructionLinkSection {...props} />}
                sectionItem={section}
              />
            )

          default:
            if (section?.renderingMode !== 'native') {
              return <DynamicPageWidget key={section.sectionName} sectionItem={section} />
            } else {
              context.logger?.warn('Unknown Native Section', { section: section.sectionName })
              return null
            }
        }
      })}
    </>
  )
}
